export const postMapper = (post: any) => ({
  ...post,
  tags: post.tags?.map(tag => ({
    name: tag,
    slug: tag.toLowerCase().split(' ').join('-')
  })),
  description: post.description.description
})